import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMobileOpen(false); }, [location]);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const heroPages = ['/', '/shop', '/about', '/gallery', '/weddings', '/contact'];
  const hasHero = heroPages.includes(location.pathname);

  const navLinkHome = { path: '/', label: 'Home' };
  const navLinksRight = [
    { path: '/shop', label: 'Shop' },
    { path: '/about', label: 'About' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/weddings', label: 'Weddings' },
    { path: '/contact', label: 'Contact' },
  ];
  const navLinksAll = [navLinkHome, ...navLinksRight];

  const renderNavLink = (link) => (
    <li key={link.path}>
      <Link
        to={link.path}
        className={`navbar__link ${location.pathname === link.path ? 'navbar__link--active' : ''}`}
      >
        {link.label}
        {location.pathname === link.path && (
          <motion.div
            className="navbar__underline"
            layoutId="navUnderline"
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          />
        )}
      </Link>
    </li>
  );

  return (
    <>
      <motion.nav
        className={`navbar ${scrolled ? 'navbar--scrolled' : ''} ${!hasHero ? 'navbar--solid' : ''}`}
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        <div className="navbar__inner container">
          <div className="navbar__left">
            <Link to="/" className="navbar__logo">
              <img src="/logo-cropped.png" alt="Cory Blossom" />
            </Link>
            <ul className="navbar__links navbar__links--left">
              {renderNavLink(navLinkHome)}
            </ul>
          </div>

          <div className="navbar__right">
            <ul className="navbar__links navbar__links--right">
              {navLinksRight.map(renderNavLink)}
            </ul>

            <button
              className={`navbar__hamburger ${mobileOpen ? 'navbar__hamburger--open' : ''}`}
              onClick={() => setMobileOpen(prev => !prev)}
              aria-label="Toggle menu"
            >
              <span /><span /><span />
            </button>
          </div>
        </div>
      </motion.nav>

      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            className="mobile-menu"
            initial={{ opacity: 0, x: '100%' }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: '100%' }}
            transition={{ duration: 0.4, ease: [0.25, 0.46, 0.45, 0.94] }}
          >
            <div className="mobile-menu__content">
              {navLinksAll.map((link, i) => (
                <motion.div key={link.path} initial={{ opacity: 0, x: 40 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.1 + i * 0.08 }}>
                  <Link to={link.path} className={`mobile-menu__link ${location.pathname === link.path ? 'mobile-menu__link--active' : ''}`}>
                    {link.label}
                  </Link>
                </motion.div>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;
